import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Escandallo/addEscandallo`, method: 'POST', body: values, token: token})
}